import { render, staticRenderFns } from "./UM_setRepayment.vue?vue&type=template&id=33834c75&scoped=true&"
import script from "./UM_setRepayment.vue?vue&type=script&lang=js&"
export * from "./UM_setRepayment.vue?vue&type=script&lang=js&"
import style0 from "./UM_setRepayment.vue?vue&type=style&index=0&id=33834c75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33834c75",
  null
  
)

export default component.exports